import { Injectable } from '@angular/core';
import { environment } from '@home/src/app/environments/environment';
import { ApiUtils } from '../Utils/apiUtils';
import { get, post } from '../../interceptors/fetch-client';

@Injectable({
  providedIn: 'root',
})
export class PrintRequestService {
  constructor() {}

  public async getPrintRequestData(data: any): Promise<any> {
    let response = null;
    try {
      const isLocalhost = window.location.hostname === 'localhost';
      let url = `${environment.getPrintRequestData}?loggedInUserEmail=${data.loggedInUserEmail}&Month=${data.month}&Year=${data.year}&groupMemberCode=${data.groupMemberCode}`;
      if (isLocalhost) {
        url += `&code=${environment.functionappCode}`;
      }
      await ApiUtils.handleApiResponse1(
        get<any>(url, {}, true), // <-- Pass `true` for Python Web API
        (data, statusCode) => {
          response = { data, statusCode };
        },
        'Failed to fetch meetings data:',
      );
    } catch (error: any) {
      console.error('Failed to fetch meetings data', error);
      response = { data: error, statusCode: error.status || error.statusCode };
    }
    return response;
  }

  public async getPrintRequestPopupData(meetingId: string): Promise<any> {
    let response = null;

    const isLocalhost = window.location.hostname === 'localhost';
    let url = `${environment.getPrintRequestPopup}?Meeting_Id=${meetingId}`;
    if (isLocalhost) {
      url += `&code=${environment.functionappCode}`;
    }
    try {
      await ApiUtils.handleApiResponse1<any>(
        get<any>(url),
        (data, statusCode) => {
          response = { data, statusCode };
        },
        'Failed to fetch print request popup data:',
      );
    } catch (error: any) {
      console.error('Failed to fetch meetings data', error);
      response = { data: error, statusCode: error.status || error.statusCode };
    }
    return response;
  }

  public async savePrintRequestPopupData(payload: any): Promise<any> {
    let response = null;

    const isLocalhost = window.location.hostname === 'localhost';
    let url = `${environment.savePrintRequestPopupSave}`;
    if (isLocalhost) {
      url += `?code=${environment.functionappCode}`;
    }
    try {
      await ApiUtils.handleApiResponse1<any>(
        post<any>(url, payload, {}, true),
        (data, statusCode) => {
          response = { data, statusCode };
        },
        'Failed to save print request data:',
      );
    } catch (error: any) {
      console.error('Failed to save print request', error);
      response = { data: error, statusCode: error.status || error.statusCode };
    }
    return response;
  }
}
